import { Button, PopIn, Text } from '~design-system'

interface Props {
  cancelLabel?: string
  content: string
  isLoading: boolean
  onValidate: () => void
  onCancel: () => void
  title: string
  validateLabel?: string
}

const ConfirmationPopin = ({
  cancelLabel = 'Non, revenir en arrière',
  content,
  isLoading,
  onValidate,
  onCancel,
  title,
  validateLabel = 'Oui, supprimer',
}: Props) => (
  <PopIn open closable onClose={onCancel}>
    <PopIn.Title textAlign="left">{title}</PopIn.Title>
    <PopIn.Content>
      <Text textColor="greyDarkest" mt={10}>
        {content}
      </Text>
    </PopIn.Content>
    <PopIn.Actions
      actions={[
        <Button
          key="cancel"
          variant="secondary"
          onClick={onCancel}
          disabled={isLoading}
        >
          {cancelLabel}
        </Button>,
        <Button
          key="save"
          type="submit"
          onClick={onValidate}
          isLoading={isLoading}
        >
          {validateLabel}
        </Button>,
      ]}
    />
  </PopIn>
)

export default ConfirmationPopin
